export default __webpack_public_path__ + "static/media/21.ea5fa4d8.jpg";